import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import "../static/css/main.css";
import "../static/css/mrgr.css";
import "../static/css/width.css";
import "../static/css/fontsize.css";
import 'amfe-flexible'
import axios from 'axios'

// 按需引入 Vant 组件
import {
  // 基础组件
  Button,
  Cell,
  CellGroup,
  Icon,
  Image,

  // 导航组件
  Tabbar,
  TabbarItem,
  NavBar,
  Sticky,
  Sidebar,
  SidebarItem,
  Tab,
  Tabs,

  // 展示组件
  Card,
  Tag,
  Swipe,
  SwipeItem,
  Grid,
  GridItem,
  Divider,

  // 表单组件
  Form,
  Field,
  Search,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
  Switch,
  Picker,

  // 反馈组件
  Toast,
  Dialog,
  Notify,
  Loading,
  PullRefresh,
  List,

  // 其他
  Popup,
  Overlay,
  ActionSheet,
  Calendar,

  Col, Row
} from 'vant'

async function initApp() {
  // 注册组件
  Vue.use(Button);
  Vue.use(Cell);
  Vue.use(CellGroup);
  Vue.use(Icon);
  Vue.use(Image);
  Vue.use(Tabbar);
  Vue.use(TabbarItem);
  Vue.use(NavBar);
  Vue.use(Sticky);
  Vue.use(Sidebar);
  Vue.use(SidebarItem);
  Vue.use(Card);
  Vue.use(Tag);
  Vue.use(Swipe);
  Vue.use(SwipeItem);
  Vue.use(Grid);
  Vue.use(GridItem);
  Vue.use(Divider);
  Vue.use(Form);
  Vue.use(Field);
  Vue.use(Search);
  Vue.use(Checkbox);
  Vue.use(CheckboxGroup);
  Vue.use(Radio);
  Vue.use(RadioGroup);
  Vue.use(Picker);
  Vue.use(Switch);
  Vue.use(Toast);
  Vue.use(Dialog);
  Vue.use(Notify);
  Vue.use(Loading);
  Vue.use(PullRefresh);
  Vue.use(List);
  Vue.use(Popup);
  Vue.use(Overlay);
  Vue.use(ActionSheet);
  Vue.use(Col);
  Vue.use(Row);
  Vue.use(Tab);
  Vue.use(Tabs);
  Vue.use(Calendar);

  // 挂载到原型
  Vue.prototype.$toast = Toast;
  Vue.prototype.$dialog = Dialog;
  Vue.prototype.$notify = Notify;

  Vue.config.productionTip = false;


  const response = await axios.get('/config.json');
  const config = response.data;
  Vue.prototype.$config = config;

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

initApp();